import React, { useEffect, useState } from "react";
import { Select, Button, Divider } from "antd";
// import { FormInstance } from "antd/es/form"; // Import FormInstance type

const { Option } = Select;

interface MutlSelectAntdComponentIF {
  options: any;
  placeholder: string;
  disabled?: boolean;
  onChangeHandler?: (selectedValues: string[]) => void;
  name?: string;
  form?: any;
  defaultValues?: any;
  maxTagCount?: number;
  mode?: any;
  showSearch?: any;
  value?: string[];
  onChange?: (value: string[]) => void;
}
const filterOption = (input: string, option: any) => {
  return (option?.children.toString() ?? "")
    .toLowerCase()
    .includes(input.toLowerCase());
};
const MutlSelectAntdComponent: React.FC<MutlSelectAntdComponentIF> = ({
  options,
  placeholder,
  disabled,
  onChangeHandler,
  form,
  name,
  maxTagCount = 1,
  value,
  onChange,
  defaultValues,
}: MutlSelectAntdComponentIF) => {
  const [selectedItems, setSelectedItems] = useState<string[]>(
    value || defaultValues || []
  );

  useEffect(() => {
    if (value) {
      setSelectedItems(value);
    } else if (defaultValues) {
      setSelectedItems(defaultValues);
    } else {
      setSelectedItems([]);
    }
  }, [value, defaultValues]);
  // Removed redundant useEffect hooks that were trying to sync state manually.
  // Component now responds to 'value' prop from Form.Item.
  const handleChange = (selectedValues: string[]) => {
    setSelectedItems(selectedValues);
    if (onChange) onChange(selectedValues);
    if (onChangeHandler) onChangeHandler(selectedValues);
    if (form && name) {
      form.setFieldsValue({ [name]: selectedValues });
      form.validateFields([name]);
    }
  };

  const handleSelectAll = () => {
    const allValues = options.map((option: any) => option.value);
    setSelectedItems(allValues);
    if (onChange) onChange(allValues);
    if (onChangeHandler) onChangeHandler(allValues);
    if (form && name) {
      form.setFieldsValue({ [name]: allValues });
      form.validateFields([name]);
    }
  };

  const handleDeselectAll = () => {
    setSelectedItems([]);
    if (onChange) onChange([]);
    if (onChangeHandler) onChangeHandler([]);
    if (form && name) {
      form.setFieldsValue({ [name]: [] });
      form.validateFields([name]);
    }
  };

  const dropdownRender = (menu: React.ReactElement) => (
    <div>
      <div
        style={{ display: "flex", justifyContent: "space-between", padding: 0 }}
      >
        <Button type="link" onClick={handleSelectAll}>
          Select All
        </Button>
        <Button type="link" onClick={handleDeselectAll}>
          Deselect All
        </Button>
      </div>
      <Divider style={{ margin: 0 }} />
      {menu}
    </div>
  );

  return (
    <div>
      <Select
        mode="multiple"
        placeholder={placeholder}
        value={selectedItems}
        disabled={disabled}
        onChange={handleChange}
        style={{ width: "100%" }}
        dropdownRender={dropdownRender}
        maxTagCount={maxTagCount}
        maxTagPlaceholder={(omittedValues) => (
          <span>+{omittedValues.length}...</span>
        )}
        filterOption={filterOption}
      >
        {options &&
          options.length &&
          options.map((option: any) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default MutlSelectAntdComponent;
